export const bytesConverter = (bytes: number) => {
  if (bytes) {
    const sizeInKB = (bytes / 1024).toFixed(0)
    const sizeInMB = (bytes / 1024 / 1024).toFixed(0)

    if (parseInt(sizeInMB) > 0) {
      return `${sizeInMB} MB`
    }
    return `${sizeInKB} KB`
  }
  return 'n/a'
}
